(function () {
  function updateTargets(mapId, html) {
    var targets = document.querySelectorAll('[data-product-variant-html-target="' + mapId + '"]');

    targets.forEach(function (el) {
      if (html) {
        el.innerHTML = html;
        el.classList.remove('product-variant-html--empty');
      } else {
        el.innerHTML = '';
        el.classList.add('product-variant-html--empty');
      }
    });
  }

  function init(mapScript) {
    var mapId = mapScript.id;
    var map = {};

    try {
      map = JSON.parse(mapScript.textContent);
    } catch (error) {
      map = {};
    }

    var initialTarget = document.querySelector('[data-product-variant-html-target="' + mapId + '"]');
    var initialVariantId = initialTarget ? initialTarget.getAttribute('data-initial-variant-id') : null;

    updateTargets(mapId, map[initialVariantId]);

    var variantSelection = document.querySelector('[data-variant-selection]');

    if (variantSelection) {
      variantSelection.addEventListener('variant-change', function (event) {
        var variant = event.detail && event.detail.variant;
        var variantId = variant ? String(variant.id) : null;

        updateTargets(mapId, map[variantId]);
      });
    }
  }

  document.querySelectorAll('[data-product-variant-html-map]').forEach(init);
})();
